<template>
  <div class="heatmap panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
